import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Mail, Smartphone } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-12 md:pt-24 md:pb-20 overflow-hidden" data-id="element-138">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-green/20 blur-[120px] rounded-full pointer-events-none" data-id="element-139" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-140">
        <div className="max-w-4xl mx-auto text-center" data-id="element-141">
          {/* Brand Name - Prominent */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="md:mb-8 pt-[0px] pb-[0px] mb-[16px] mt-[-47px]" data-id="element-142">
            <span className="inline-flex items-center gap-2 text-brand-light font-bold text-lg sm:text-3xl md:text-4xl tracking-wider font-[Poppins,_sans-serif]" data-id="element-143">
              🌿 BIOMA LÍVIDO™
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-5 md:mb-8" data-id="element-144">
            <h1 className="text-2xl sm:text-5xl md:text-6xl lg:text-7xl font-bold font-[Poppins,_sans-serif] leading-tight mt-[-5px] mb-[-25px]" data-id="element-145">
              Evacuá sola y sin esfuerzo en{' '}
              <span className="text-brand-light" data-id="element-146">21 días</span>, sin depender de
              laxantes.
            </h1>
          </motion.div>

          {/* Product Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative max-w-[16rem] md:max-w-lg mx-auto mb-6 md:mb-10" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/tjfxrh7ray4Un9KhS8jDZL/Mockup_-_SN2_(2).png" alt="Sistema Despertar Liviana Mockup" loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto drop-shadow-2xl mt-[-20px] mb-[-20px]" data-id="element-148" />
          </motion.div>

          {/* Subtitle & Description */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mb-5 md:mb-6" data-id="element-149">
            <h2 className="text-brand-gold font-bold text-base sm:text-xl md:text-2xl mb-3 md:mb-4" data-id="element-150">
              SISTEMA DESPERTAR LIVIANA™
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-200 px-2 max-w-2xl mx-auto leading-relaxed mb-[-10px]" data-id="element-151">
              Un sistema simple basado en alimentos de cualquier verdulería o
              farmacia de Argentina, sin pastillas ni adivinanzas.
            </p>
          </motion.div>

          {/* Feature Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-2 md:gap-3 md:mb-10 text-xs md:text-sm font-medium text-gray-300 mb-[13px]" data-id="element-152">
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-153">
              <Mail className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-light" data-id="element-154" />
              Acceso inmediato por Email
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-155">
              <Smartphone className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-156" />
              Lectura en tu celular o PC
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-157">
            <Button href="#pricing" showBadges className="text-base md:text-xl py-5 md:py-6 px-6 md:px-10 w-full max-w-lg font-bold" data-id="element-158">
              🌿 QUIERO MI SISTEMA DESPERTAR LIVIANA AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}